import { render, staticRenderFns } from "./OrganismCredential.vue?vue&type=template&id=4a71a316&scoped=true&"
import script from "./OrganismCredential.vue?vue&type=script&lang=js&"
export * from "./OrganismCredential.vue?vue&type=script&lang=js&"
import style0 from "./OrganismCredential.vue?vue&type=style&index=0&id=4a71a316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71a316",
  null
  
)

export default component.exports